const DEFAULT_PER_PAGE_KEY = 'default-per-page';

/**
 * Get default per page.
 * @returns {number | null}
 */
function getDefaultPerPage() {
  const perPage = localStorage.getItem(DEFAULT_PER_PAGE_KEY);
  return perPage != null ? Number(perPage) : null;
}

/**
 * Set default per page.
 * @param {number} page Page to set.
 */
function setDefaultPerPage(page) {
  localStorage.setItem(DEFAULT_PER_PAGE_KEY, page.toString());
}

export const queryParamsStorageService = {
  setDefaultPerPage,
  getDefaultPerPage,
};
